var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9165",
    "data-name": "Group 9165",
    transform: "translate(-21 -223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3690",
    "data-name": "Rectangle 3690",
    transform: "translate(21 223)",
    fill: "none",
    stroke: "#2a292b",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.55,
    y: 0.55,
    width: 6.9,
    height: 6.9,
    rx: 0.45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3692",
    "data-name": "Rectangle 3692",
    transform: "translate(30 232)",
    fill: "none",
    stroke: "#2a292b",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.55,
    y: 0.55,
    width: 5.9,
    height: 5.9,
    rx: 0.45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3691",
    "data-name": "Rectangle 3691",
    transform: "translate(30 224)",
    fill: "none",
    stroke: "#2a292b",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.55,
    y: 0.55,
    width: 5.9,
    height: 5.9,
    rx: 0.45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3693",
    "data-name": "Rectangle 3693",
    transform: "translate(21 232)",
    fill: "none",
    stroke: "#2a292b",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 7,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.55,
    y: 0.55,
    width: 6.9,
    height: 5.9,
    rx: 0.45,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.fbb70d0e4e8d57373be16c5e035457c1.svg";
export { ForwardRef as ReactComponent };